import React from 'react';
import ReactDOM from 'react-dom';
import {createStore} from 'redux'
import{HashRouter} from 'react-router-dom';
//import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import App from './App';
//import { from } from 'apollo-boost';
import { Provider } from 'react-redux';
import { store } from './_helpers';

ReactDOM.render((    
     <HashRouter>
     <Provider store={store}>     
     <App />      
    </Provider>
     </HashRouter>
), document.getElementById('root'));

serviceWorker.unregister();
